<template>
  <div ref="popoverRef" class="popover">
    <div
      class="popover__trigger"
      @mousedown.prevent
      @click="toggleVisible"
    >
      <slot name="trigger" />
    </div>
    <div v-if="modelValue" class="popover__content z-index__10">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
type Props = {
  modelValue?: boolean
}

type Emits = {
  (eventName: 'update:modelValue', value: boolean): void
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: false
})

const emit = defineEmits<Emits>()

const popoverRef = ref()

const handleClickOutside = (event: Event) => {
  if (popoverRef.value.contains(event.target as HTMLElement)) { return }

  emit('update:modelValue', false)
}

const toggleVisible = () => {
  emit('update:modelValue', !props.modelValue)
}

watch(() => props.modelValue, (isVisible: boolean) => {
  if (isVisible) {
    document.addEventListener('click', handleClickOutside)
  } else {
    document.removeEventListener('click', handleClickOutside)
  }
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style lang="scss">
.popover {
  display: flex;
  position: relative;

  &__trigger {
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  &__content {
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    border-radius: 8px;
    background-color: $white-color;
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    min-width: min-content;
    right: 0;
    top: 0;
  }
}
</style>
